import React from 'react';

function FutureWorks() {
  return (
    <div className="row">
      <div className="w-100">
        <p>
          We're currently studying the use of an <strong>interconnected system of reservoirs</strong> in predicting the decomposed system of delay differential equations that govern the insulin-glucose cycle.
        </p>
        <p>
          Additionally, we want to implement and train a <strong>convolutional training network</strong> (CNN) to recognize the parameters a reservoir needs to predict a series.
          The two parameters we configured, reservoir units and spectral radius, can not be exhaustively tuned due to the resources needed to generate large reservoirs.
          We hope to discover a trained solution for picking reservoir generation parameters.
        </p>
      </div>
    </div>
  );
}

export default FutureWorks;
